
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

// TODO: Move all settings-related params to "settings"
// When adding new settings, add them to the initSettings function in
// "settings/actions.js", too.

const state = {
  // see vue.config.js to learn how to import version from package.json
  // packageVersion: process.env.VUE_APP_VERSION || '0',
  dbReady: false,
  vueAppVersion: null,
  //
  // ----- Geolocation settings
  //
  // Specific to OpenLayers: if true, watchPosition is activated and a watcherID is created
  // Update: redefine usage of this params: manage the global app access permission.
  // If this param is not set, the functions to record will simply not show up.
  trackingAllowed: false,
  sensorsAllowed: false,
  // TODO:
  // permission: null,
  geolocationPermissionStatus: 'prompt',
  gyroscopePermissionStatus: 'prompt',
  //
  // Geolocation specifics
  //
  enableHighAccuracy: false,
  maximumAge: 0,
  timeout: 5000,
  //
  // ----- Reverse Geocoding
  //
  addressService: 'none',
  //
  // ------ Geolocation Recording constraints
  //
  // The minimum value of the geolocation Psoition's speed param, below which
  // there won't be any recording of data
  useMinSpeedThreshold: false,
  minSpeedThreshold: 0.9,
  // Time interval: only save a GPS value every xy mmilliseconds
  useRecordingTimeInterval: false,
  recordingTimeInterval: 1500,
  //
  // ----- Notification when not moving
  //
  showNotificationWhenNotMoving: true,
  //
  // ----- Zoom
  //
  zoomLevelNear: 16,
  zoomLevelFar: 0,
  zoomLevelManual: undefined,
  //
  // ----- Pagination: Max items per page
  //
  maxMapHostsPerPage: 0,
  maxNotesPerPage: 0,
  maxTrackedRoutesPerPage: 0,
  //
  // ----- Device settings
  //
  // Call this "screenWakeLock" in order to not be confused
  // with the JS native "wakeLock" function
  screenWakeLockAvailability: false,
  //
  // ------ Sensores
  //
  usePedometer: false,
  //
  // ----- Console, debugging and log string
  //
  console: false,
  debugging: false,
  log: '',
  //
  // Needs more attention
  //
  // TODO: Add action and mutation
  saveAccidentallyInterruptedRecording: false
}

export default {
  state,
  mutations,
  actions,
  getters
}
